import * as React from 'react'
import { AuthService } from '../utils/auth'
import { IAuthContext, IAuthContextProvider } from './interface'

const AuthContext = React.createContext({} as IAuthContextProvider)

const AuthContextProvider = ({ children }: IAuthContext) => {
  const authService = AuthService.getInstance()
  return <AuthContext.Provider value={{ authService }}>{children}</AuthContext.Provider>
}

export { AuthContext, AuthContextProvider }
